import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function getCertificateTypeDescriptions({ activityId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Activity/GetCertificateTypeDescriptions',
    params: { ActivityId: activityId },
  });
  return data;
}

async function addCertificate({
  activityCVId,
  certificateTypeId,
  description,
  issueDate,
  expirationDate,
}) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/AddCertificate',
    data: sanitizePostData({
      activityCVId,
      certificateTypeId,
      description,
      issueDate,
      expirationDate,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function updateCertificate({
  certificateId,
  certificateTypeId,
  description,
  issueDate,
  expirationDate,
}) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/UpdateCertificate',
    data: sanitizePostData({
      certificateId,
      certificateTypeId,
      description,
      issueDate,
      expirationDate,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function removeCertificate({ certificateId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RemoveCertificate',
    data: sanitizePostData({
      certificateId,
    }),
  });
  return data;
}

export {
  getCertificateTypeDescriptions,
  addCertificate,
  updateCertificate,
  removeCertificate,
};
